import { graphql } from '~/gql'

const FACILITY_SEARCH_QUERY = graphql(`
  query FacilitySearch(
    $orderBy: String
    $filter: FacilityFilter
    $limit: Int
    $page: Int
    $allUsers: Boolean
  ) {
    facilitySearch: facilitySearch(
      orderBy: $orderBy
      filter: $filter
      limit: $limit
      page: $page
      allUsers: $allUsers
    ) {
      facilities {
        ...FacilityFragment
        floors {
          id
          versions {
            id
          }
        }
        floor {
          id
          version {
            id
          }
        }
      }
      count
    }
  }
`)

export default FACILITY_SEARCH_QUERY
